import { motion } from "framer-motion";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { profileData } from "../data/profileData";

const Skills = () => {
	const { ref, inView } = useScrollAnimation();

	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: { staggerChildren: 0.1 },
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 20 },
		visible: {
			opacity: 1,
			y: 0,
			transition: { duration: 0.5 },
		},
	};

	return (
		<section id="skills" className="section-card" ref={ref}>
			<motion.div
				initial="hidden"
				animate={inView ? "visible" : "hidden"}
				variants={containerVariants}
			>
				<motion.div className="section-header" variants={itemVariants}>
					<span>Skills</span>
					<h2>Technical expertise</h2>
				</motion.div>
				<motion.div className="skills-grid" variants={containerVariants}>
					{profileData.skills.map((group, index) => (
						<motion.div
							key={group.category}
							className={`skill-group skill-group-${index}`}
							variants={itemVariants}
						>
							<h3>{group.category}</h3>
							<div className="skill-chip-grid">
								{group.items.map((skill) => (
									<span key={skill} className="skill-chip">
										{skill}
									</span>
								))}
							</div>
						</motion.div>
					))}
				</motion.div>
			</motion.div>
		</section>
	);
};

export default Skills;
